import viewpaths from "global/constants/ViewPathConstants";

/**
 * Navigation utility for use outside React components
 * Uses window.location for navigation
 */
export const navigateTo = (path: string) => {
  window.location.href = path;
};

/**
 * Navigate to home page
 */
export const navigateToHome = () => {
  navigateTo(viewpaths.landingViewPath);
};
